import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=c8fc3436&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=c8fc3436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc3436",
  null
  
)

export default component.exports